<template>
    <div class="msg">
        <div class="user-mes-box">
            <div class="user-mes-title" v-text="userText"></div>
            <div class="user-mes">
                <div class="user-mes-in cle" v-for="(items,index) in mes" :key="index">
                    <div v-text="items.name" class="user-mes-name fl"></div>
                    <input :type="items.type" maxlength="16" class="user-mes-inp fr" v-model="items.val" @keyup="keyUp($event,index)" :disabled="items.dis">
                </div>
                <div class="user-mes-btn cle">
                    <button type="button" class="fl" @click="confirm" :title="modifyText" v-text="modifyText"></button>
                    <button type="button" class="fr" @click="cancle" :title="cancleText" v-text="cancleText"></button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import user from '../assets/js/bomb'
export default {
    name:'UserMes',
    props:['language','userName'],
    data(){
        return{
            userText:'',
            isLang:false,
            user:'',
            mes:[
                {name:'',type:'text',val:'',dis:true},
                {name:'',type:'password',val:'',dis:false},
                {name:'',type:'password',val:'',dis:false},
                //   {name:'',type:'text',val:'',dis:false}
            ],
            modifyText:'',
            cancleText:''
        }
    },
    methods:{
        confirm:function(){
            var pwdN=this.reg.rPwd.num;
            var pwdl1=this.StrByteCountFun(this.mes[2].val);
                if(!(pwdl1>=pwdN[0]&&pwdl1<=pwdN[1])){
                    alert(this.language['K202_Limit']);
                    return;
                };
                if(!this.reg.rPwd.limit.test(this.mes[2].val)){
                    alert(this.language['K203_Type']);
                    return;
                };

            var sessionId=this.ajaxH.session;
            var oem=this.baseData.oem;
            var str=user.userMesSet({
                sessionId:sessionId,
                oem:oem,
                old:this.hashEncryption(this.mes[1].val),
                new:this.hashEncryption(this.mes[2].val)
            });
            var data=this.ajaxSet({
                ip:this.cloudName,
                type:'auth/user',
                xml:str
            });
            this.confirmResult(data.data);
        },
        confirmResult:function(data){
            if(!data){
                this.$emit('msgHide',false);
            }else{
                var result=$(data).find('header').find('result').text();
                var key = this.promptInfo(result);
                if(result==='0'){
                    // localStorage.setItem('pwd',unescape(this.mes[2].val));
                    alert(this.language["K116_Modify_Successfully"]);
                    alert(this.language["K219_Logout"]);
                    this.$router.push('./');
                    window.location.reload(true);
                    // this.$emit('msgHide',false);
                    // this.$emit('refresh');
                }else if(result==='100100001'||result===''){
                    this.ajaxH.repeat=this.confirm;
                    this.$emit('refresh');
                }else{
                    alert(this.language[key] == undefined ? key : this.language[key]);
                };
            };
        },
        cancle:function(){
            this.$emit('msgHide',false);
        },
        keyUp:function(name,index){
            
        },
        lang:function(){
            this.mes[1].val='';
            this.mes[2].val='';
            //   this.mes[3].val='';
            if(!this.isLang){
                this.isLang=true;
                this.userText=this.language['K048_UserInfo'];
                this.mes=[
                    {name:this.language['K002_UserName'],type:'text',val:'',dis:true},
                    {name:this.language['K025_OldPwd'],type:'password',val:'',dis:false},
                    {name:this.language['K026_NewPwd'],type:'password',val:'',dis:false},
                    // {name:this.language['K013_Email'],type:'text',val:'',dis:false}
                ];
                this.modifyText=this.language['K027_Modify'];
                this.cancleText=this.language['K018_Cancel'];
                this.user=this.userName;
                this.mes[0].val=this.user;
            };
            
        }
    }
}
</script>
<style scoped>
    .msg{
        position:fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background-color:rgba(0, 0, 0, .5);
    }
    .user-mes-box{
        width:400px;
        height:240px;
        background-color: #EFF2F9;
        font-size:12px;
        position:absolute;
        top:50%;
        left:50%;
        margin-top:-120px;
        margin-left:-200px;
    }
    .user-mes-title{
        width:100%;
        height:24px;
        line-height:24px;
        text-align: center;
        background-color: #364860;
        color:#fff;
    }
    .user-mes{
        width:100%;
        height:calc(100% - 24px);
        padding:20px;
        box-sizing: border-box;
    }
    .user-mes-in{
        width:100%;
        height:30px;
    }
    .user-mes-in+.user-mes-in{
        margin-top:10px;
    }
    .user-mes-name{
        width:120px;
        height:100%;
        line-height:30px;
    }
    .user-mes-inp{
        width:calc(100% - 120px - 20px);
        height: 100%;
        box-sizing: border-box;
        border:1px solid #ccc;
        outline: none;
    }
    .user-mes-btn{
        width:100%;
        height:30px;
        margin-top:30px;
    }
    .user-mes-btn button{
        width:80px;
        height:100%;
        background-color: #EFF2F9;
        box-sizing: border-box;
        border:1px solid #364860;
        outline: none;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>
<style scoped>
    @import '../assets/css/cloudPop.css';  
</style>





// WEBPACK FOOTER //
// src/components/UserMes.vue